/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScheduleIntervalType = 'Daily' | 'Weekly' | 'Monthly' | 'Yearly';

export const ScheduleIntervalType = {
    Daily: 'Daily' as ScheduleIntervalType,
    Weekly: 'Weekly' as ScheduleIntervalType,
    Monthly: 'Monthly' as ScheduleIntervalType,
    Yearly: 'Yearly' as ScheduleIntervalType
};

